import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const pictogramimages = 
{
    namespaced: true,
    state: {
        pictogramimages: [],
        pictogramimage: {}
    },
    mutations: {
        SET_PICTOGRAMIMAGES(state, data)
        {
            state.pictogramimages = data
        },
        SET_PICTOGRAMIMAGE(state, data)
        {
            state.pictogramimage = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'PictogramImages', { withCredentials: true })
          .then(res => {
              console.log(res.data);
              commit('SET_PICTOGRAMIMAGES', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deletePictogramImages ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updatePictogramImages({ commit }, {id, data}){
            return axios
            .post(baseUrl+'PictogramImages/updatePictogramImages/'+id, data, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getPictogramImages ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewPictogramImages ({ commit }, data) {
            return axios
            .post(baseUrl+'PictogramImages/addPictogramImages', data, { withCredentials: true })
            .then(res => {
                console.log("new pictogram image added",res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default pictogramimages